(function () {
  // PostNL parcels: confirmed end-of-year 2026 schedule and recurring spring closures.
  // https://www.postnl.nl/zakelijk/klantenservice/versturen-bezorgen/aangepaste-bezorgdagen-vertragingen/feestdagen/
  // Destination estimates use national calendars through 2027, excluding region-only closures.
  // https://eures.europa.eu/eures-services/chat-eures-advisers/public-holidays-calendar_en
  // https://legimonaco.mc/tnc/loi/1966/02-18-798/
  // Belgium also observes the PostNL parcel closure on 26 December 2026.
  // https://www.postnl.be/contact/bezorging-rond-de-feestdagen/
  const netherlands = '2026-12-25 2026-12-26 2027-01-01 2027-03-28 2027-03-29 2027-04-27 2027-05-06 2027-05-16 2027-05-17 2027-12-25 2027-12-26';
  const holidays = {
    NL: netherlands,
    AT: '2026-12-08 2026-12-25 2026-12-26 2027-01-01 2027-01-06 2027-03-29 2027-05-01 2027-05-06 2027-05-17 2027-05-27 2027-08-15 2027-10-26 2027-11-01 2027-12-08 2027-12-25 2027-12-26',
    BE: '2026-11-11 2026-12-25 2026-12-26 2027-01-01 2027-03-29 2027-05-01 2027-05-06 2027-05-17 2027-07-21 2027-08-15 2027-11-01 2027-11-11 2027-12-25',
    BG: '2026-12-24 2026-12-25 2026-12-26 2027-01-01 2027-03-03 2027-04-30 2027-05-01 2027-05-02 2027-05-03 2027-05-04 2027-05-06 2027-05-24 2027-09-06 2027-09-22 2027-12-24 2027-12-25 2027-12-26 2027-12-27 2027-12-28',
    CZ: '2026-11-17 2026-12-24 2026-12-25 2026-12-26 2027-01-01 2027-03-26 2027-03-29 2027-05-01 2027-05-08 2027-07-05 2027-07-06 2027-09-28 2027-10-28 2027-11-17 2027-12-24 2027-12-25 2027-12-26',
    DE: '2026-12-25 2026-12-26 2027-01-01 2027-03-26 2027-03-29 2027-05-01 2027-05-06 2027-05-17 2027-10-03 2027-12-25 2027-12-26',
    DK: '2026-12-24 2026-12-25 2026-12-26 2027-01-01 2027-03-25 2027-03-26 2027-03-28 2027-03-29 2027-05-06 2027-05-16 2027-05-17 2027-12-24 2027-12-25 2027-12-26',
    EE: '2026-12-24 2026-12-25 2026-12-26 2027-01-01 2027-02-24 2027-03-26 2027-03-28 2027-05-01 2027-05-16 2027-06-23 2027-06-24 2027-08-20 2027-12-24 2027-12-25 2027-12-26',
    ES: '2026-12-08 2026-12-25 2027-01-01 2027-01-06 2027-03-26 2027-05-01 2027-10-12 2027-11-01 2027-12-06 2027-12-08 2027-12-25',
    FI: '2026-12-06 2026-12-24 2026-12-25 2026-12-26 2027-01-01 2027-01-06 2027-03-26 2027-03-28 2027-03-29 2027-05-01 2027-05-06 2027-05-16 2027-06-25 2027-06-26 2027-11-06 2027-12-06 2027-12-24 2027-12-25 2027-12-26',
    FR: '2026-11-11 2026-12-25 2027-01-01 2027-03-29 2027-05-01 2027-05-06 2027-05-08 2027-05-17 2027-07-14 2027-08-15 2027-11-01 2027-11-11 2027-12-25',
    GR: '2026-12-25 2026-12-26 2027-01-01 2027-01-06 2027-03-15 2027-03-25 2027-04-30 2027-05-01 2027-05-02 2027-05-03 2027-06-21 2027-08-15 2027-10-28 2027-12-25 2027-12-26',
    HR: '2026-11-18 2026-12-25 2026-12-26 2027-01-01 2027-01-06 2027-03-28 2027-03-29 2027-05-01 2027-05-27 2027-05-30 2027-06-22 2027-08-05 2027-08-15 2027-11-01 2027-11-18 2027-12-25 2027-12-26',
    HU: '2026-12-25 2026-12-26 2027-01-01 2027-03-15 2027-03-26 2027-03-29 2027-05-01 2027-05-17 2027-08-20 2027-10-23 2027-11-01 2027-12-25 2027-12-26',
    IE: '2026-12-25 2026-12-28 2027-01-01 2027-02-01 2027-03-17 2027-03-29 2027-05-03 2027-06-07 2027-08-02 2027-10-25 2027-12-25 2027-12-26 2027-12-27 2027-12-28',
    IT: '2026-12-08 2026-12-25 2026-12-26 2027-01-01 2027-01-06 2027-03-29 2027-04-25 2027-05-01 2027-06-02 2027-08-15 2027-10-04 2027-11-01 2027-12-08 2027-12-25 2027-12-26',
    LT: '2026-12-24 2026-12-25 2026-12-26 2027-01-01 2027-02-16 2027-03-11 2027-03-28 2027-03-29 2027-05-01 2027-05-02 2027-06-06 2027-06-24 2027-07-06 2027-08-15 2027-11-01 2027-11-02 2027-12-24 2027-12-25 2027-12-26',
    LU: '2026-12-25 2026-12-26 2027-01-01 2027-03-29 2027-05-01 2027-05-06 2027-05-09 2027-05-17 2027-06-23 2027-08-15 2027-11-01 2027-12-25 2027-12-26',
    LV: '2026-11-18 2026-12-24 2026-12-25 2026-12-26 2026-12-31 2027-01-01 2027-03-26 2027-03-28 2027-03-29 2027-05-01 2027-05-04 2027-05-09 2027-05-16 2027-06-23 2027-06-24 2027-11-18 2027-12-24 2027-12-25 2027-12-26 2027-12-31',
    MC: '2026-11-19 2026-12-08 2026-12-25 2027-01-01 2027-01-27 2027-03-29 2027-05-01 2027-05-06 2027-05-17 2027-05-27 2027-08-15 2027-08-16 2027-11-01 2027-11-19 2027-12-08 2027-12-25',
    PL: '2026-11-11 2026-12-24 2026-12-25 2026-12-26 2027-01-01 2027-01-06 2027-03-28 2027-03-29 2027-05-01 2027-05-03 2027-05-16 2027-05-27 2027-08-15 2027-11-01 2027-11-11 2027-12-24 2027-12-25 2027-12-26',
    PT: '2026-12-01 2026-12-08 2026-12-25 2027-01-01 2027-03-26 2027-03-28 2027-04-25 2027-05-01 2027-05-27 2027-06-10 2027-08-15 2027-10-05 2027-11-01 2027-12-01 2027-12-08 2027-12-25',
    RO: '2026-11-30 2026-12-01 2026-12-25 2026-12-26 2027-01-01 2027-01-02 2027-01-06 2027-01-07 2027-01-24 2027-04-30 2027-05-01 2027-05-02 2027-05-03 2027-06-01 2027-06-20 2027-06-21 2027-08-15 2027-11-30 2027-12-01 2027-12-25 2027-12-26',
    SE: '2026-12-24 2026-12-25 2026-12-26 2026-12-31 2027-01-01 2027-01-06 2027-03-26 2027-03-28 2027-03-29 2027-05-01 2027-05-06 2027-05-16 2027-06-06 2027-06-26 2027-11-06 2027-12-24 2027-12-25 2027-12-26 2027-12-31',
    SI: '2026-12-25 2026-12-26 2027-01-01 2027-01-02 2027-02-08 2027-03-28 2027-03-29 2027-04-27 2027-05-01 2027-05-02 2027-05-16 2027-06-25 2027-08-15 2027-10-31 2027-11-01 2027-12-25 2027-12-26',
    SK: '2026-12-24 2026-12-25 2026-12-26 2027-01-01 2027-01-06 2027-03-26 2027-03-29 2027-05-01 2027-05-08 2027-07-05 2027-08-29 2027-09-15 2027-11-01 2027-12-24 2027-12-25 2027-12-26',
  };
  const earlyCutoffs = {
    '2026-12-24': 20 * 60,
    '2026-12-31': 20 * 60,
  };
  const standardCutoff = 23 * 60 + 30;
  const originClosures = new Set(netherlands.split(' '));
  const destinationClosures = Object.fromEntries(
    Object.entries(holidays).map(([country, dates]) => [country, new Set(dates.split(' '))])
  );
  const amsterdamClock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Amsterdam', hourCycle: 'h23',
    year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric',
  });

  function dateKey(date) {
    return date.toISOString().slice(0, 10);
  }

  function addDay(date) {
    const next = new Date(date.getTime());
    next.setUTCDate(next.getUTCDate() + 1);
    return next;
  }

  function showCutoff(specialCutoff) {
    const times = [
      ['23:30', '20:00'], ['23.30', '20.00'],
      ['23 h 30', '20 h 00'], ['11:30 pm', '8:00 pm'],
    ];
    document.querySelectorAll('[data-bezorg-cutoff]').forEach(note => {
      let text = note.textContent;
      for (const [usual, early] of times) {
        text = specialCutoff ? text.replace(usual, early) : text.replace(early, usual);
      }
      if (note.textContent !== text) note.textContent = text;
    });
  }

  function schedule(now = new Date()) {
    const parts = Object.fromEntries(amsterdamClock.formatToParts(now).map(part => [part.type, Number(part.value)]));
    const today = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
    const todayKey = dateKey(today);
    const cutoff = earlyCutoffs[todayKey] ?? standardCutoff;
    let dispatch = parts.hour * 60 + parts.minute < cutoff ? today : addDay(today);
    while (dispatch.getUTCDay() === 6 || originClosures.has(dateKey(dispatch))) {
      dispatch = addDay(dispatch);
    }

    function arrival(days, country, saturday = true) {
      const closed = destinationClosures[country];
      let date = dispatch;
      for (let remaining = days; remaining > 0;) {
        date = addDay(date);
        const weekday = date.getUTCDay();
        if (weekday !== 0 && (weekday !== 6 || saturday) && !closed?.has(dateKey(date))) {
          remaining--;
        }
      }
      return date;
    }

    return { today, tomorrow: addDay(today), dispatch, specialCutoff: cutoff !== standardCutoff, arrival };
  }

  window.shopDeliverySchedule = schedule;
  window.shopDeliveryShowCutoff = showCutoff;
})();
